import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import openIcon from 'assets/svg/navigation/icon_interactive.svg';
import openIconFocused from 'assets/svg/navigation/icon_interactive_on.svg';

import Infopanel from 'components/Infopanel';

import { media } from 'media';
import { TabletUp } from '../../media';


// bottom: ${(props) => props.bottom && `calc(-100vh * ${props.bottom} / 100)`};
const Base = styled.div`
  height: ${(props) => (props.height ? `calc(100vh * ${props.height} / 100)` : 'auto')};
  width: auto;
  top: ${(props) => props.top && `${props.top}%`};
  right: ${(props) => props.right && `${props.right}%`};
  bottom: ${(props) => props.bottom && `${props.bottom}%`};
  left: ${(props) => props.left && `${props.left}%`};
`;
const ClickableArea = Base.extend`
  cursor: ${(props) => (props.ignoreEvents ? 'auto' : 'pointer')};
  position: absolute;
  pointer-events: ${(props) => (props.ignoreEvents ? 'none' : 'auto')};
  z-index: ${(props) => props.zindex || (props.ignoreEvents && 1) || 'auto'};
`;
const InfoPanelWrapper = Base.extend`
  position: absolute;
`;
const ButtonIcon = styled.img`
  position: relative;
  display: block;
  height: calc(100vh * 2.65 / 100);
  transition: all 3s ease-in-out;
  transform: ${(props) => (props.isActive ? 'rotate(45deg)' : 'rotate(0deg)')};
  transition: all 0.2s ease 0s;
  z-index: ${(props) => (props.isActive ? '3' : 'auto')};
  ${media.tablet`
    z-index: auto;
  `}
`;
const Img = Base.withComponent('img');


class ForegroundItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasFocus: false,
    };
  }

  handleClick = () => {
    if (!this.props.item.infopanel) return;
    this.props.toggleItem(this.props.id);
  }

  handleMouseEnter = () => {
    if (!this.props.item.infopanel) return;
    this.setState({ hasFocus: true });
  }

  handleMouseLeave = () => {
    if (!this.props.item.infopanel) return;
    this.setState({ hasFocus: false });
  }

  render() {
    const { item, isActive, closePanel } = this.props;
    const itemSrc = ((isActive || this.state.hasFocus) ? item.activeSrc : item.baseSrc);
    const btnSrc = ((isActive || this.state.hasFocus) && openIconFocused) || openIcon;


    return (
      <ClickableArea
        onClick={this.handleClick}
        height={item.height}
        top={item.top}
        right={item.right}
        bottom={item.bottom}
        left={item.left}
        ignoreEvents={item.ignoreEvents}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        zindex={item.depth}
      >
        <Img
          src={itemSrc}
          height={item.height}
        />

        {item.infopanel && item.infopanel.button &&
          <InfoPanelWrapper
            top={item.infopanel.button.top}
            right={item.infopanel.button.right}
            bottom={item.infopanel.button.bottom}
            left={item.infopanel.button.left}
          >
            <TabletUp>
              {isActive &&
                <Infopanel
                  id={item.id}
                  onClose={closePanel}
                  alignX={item.infopanel.overlay.x}
                  alignY={item.infopanel.overlay.y}
                  title={item.infopanel.content.title}
                  description={item.infopanel.content.description}
                  link={item.infopanel.content.link}
                />
              }
            </TabletUp>
            <ButtonIcon src={btnSrc} isActive={isActive} />
          </InfoPanelWrapper>
        }
      </ClickableArea>
    );
  }
}

ForegroundItem.propTypes = {
  id: PropTypes.string.isRequired,
  item: PropTypes.object.isRequired,
  isActive: PropTypes.bool,
  toggleItem: PropTypes.func.isRequired,
  closePanel: PropTypes.func.isRequired,
};

ForegroundItem.defaultProps = {
  isActive: false,
};

export default ForegroundItem;



// WEBPACK FOOTER //
// ./src/components/ForegroundItem/ForegroundItem.js